import React from 'react';
import "./index.css";


export const DemoBlock = (props) => {
  return (
    <div className="demoBlock" hidden={props.hidden} >
      <div  className="title">{props.title}</div>
      <div
        className="main"
        style={{
          padding: props.padding,
          background: props.background,
          
        }}
      >
        {props.children}
      </div>
    </div>
  );
};

DemoBlock.defaultProps = {
  padding: '12px 12px',
  background: 'var(--adm-color-background)',
}

